import { Preferences as Storage } from '@capacitor/preferences';

const HAS_LOGGED_IN = 'hasLoggedIn';
const USERNAME = 'username';

export const getUserData = async () => {
  const response = await Promise.all([
    Storage.get({ key: HAS_LOGGED_IN }),
    Storage.get({ key: USERNAME }),
  ]);
  const isLoggedin = (await response[0].value) === 'true';
  const username = (await response[1].value) || undefined;
  const data = {
    isLoggedin,
    username,
  };
  return data;
};

export const setIsLoggedInData = async (isLoggedIn: boolean) => {
  await Storage.set({ key: HAS_LOGGED_IN, value: JSON.stringify(isLoggedIn) });
};

export const setUsernameData = async (username?: string) => {
  if (!username) {
    await Storage.remove({ key: USERNAME });
  } else {
    await Storage.set({ key: USERNAME, value: username });
  }
};